import httpClient from './httpClient'

export default {
  async getTrafficDetails(date, videoIds = null) {
    let ret = await httpClient.get(
      `/analytics/traffic?type=general&date=${date}&view=detailed`
    )
    if (ret.data && videoIds && videoIds.length > 0) {
      const filteredData = {}

      videoIds.forEach((id) => {
        if (ret.data.hasOwnProperty(id)) {
          filteredData[id] = ret.data[id]
        }
      })
      ret.data = filteredData
    }

    return ret
  },
}
